import React from "react";
import { Card, CardBody, Table, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import avtarImage1 from "../../assets/images/users/avatar-1.jpg";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";

const BotList = ({ onClick_Sort_By_Column, filter, onDelete_Bot }) => {
  const bot_list_data = useSelector((state) => state.Bot_List);
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Card>
        <CardBody className="no_padding">
          <div className="listjs-table" id="customerList">
            <div className="table-responsive">
              <table
                className="table align-middle table-nowrap  no_margin"
                id="customerTable"
              >
                <thead className="table-light">
                  <tr>
                    <th>Action</th>
                    <th>Bot Title</th>
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <th
                      onClick={() => {
                        onClick_Sort_By_Column("Group_Name");
                      }}
                      className={`${
                        filter.sort_by === "Group_Name" &&
                        (filter.sort_order === "ASC" ? "up" : "down")
                      }`}
                      data-sort="group"
                    >
                      Group
                    </th>
                    {/* <th className={`${filter.sort_by==='Group_Name'?'sort':""}`} data-sort="modal_type">Modal</th> */}
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <th
                      onClick={() => {
                        onClick_Sort_By_Column("Type");
                      }}
                      className={`${
                        filter.sort_by === "Type" &&
                        (filter.sort_order === "ASC" ? "up" : "down")
                      }`}
                      data-sort="type"
                    >
                      Type
                    </th>
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <th
                      onClick={() => {
                        onClick_Sort_By_Column("BOT_Category");
                      }}
                      className={`${
                        filter.sort_by === "BOT_Category" &&
                        (filter.sort_order === "ASC" ? "up" : "down")
                      }`}
                      data-sort="category"
                    >
                      Category
                    </th>
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                    <th
                      onClick={() => {
                        onClick_Sort_By_Column("User_Role");
                      }}
                      className={`${
                        filter.sort_by === "User_Role" &&
                        (filter.sort_order === "ASC" ? "up" : "down")
                      }`}
                      data-sort="user_type"
                    >
                      User Type
                    </th>
                    <th className="" data-sort="last_use">
                      Last Use
                    </th>
                  </tr>
                </thead>
                <tbody className="list form-check-all">
                  {bot_list_data.botList.map((ele, i) => {
                    const {
                      Assets_ID,
                      Bot_Title,
                      Group_Name,
                      Model,
                      Type,
                      BOT_Category,
                      User_Role,
                      Last_Active_Date_Time,
                      Bot_ID,
                      Bot_Logo,
                    } = ele;
                    // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                    return (
                      <tr key={i}>
                        <td>
                          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                          <i
                            className="mdi mdi-eye-circle-outline"
                            onClick={() => {
                              navigate("/Configuration", {
                                state: {
                                  Bot_ID,
                                  Assets_ID,
                                },
                              });
                            }}
                          />

                          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                          {User_Role === "BotAdmin" && (
                            <span>
                              <i
                                onClick={() => {
                                  onDelete_Bot(Bot_ID);
                                }}
                                className="ri-delete-bin-line"
                              />
                            </span>
                          )}
                        </td>
                        <td>
                          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                          <div
                            onClick={() => {
                              navigate("/Configuration", {
                                state: {
                                  Bot_ID,
                                  Assets_ID,
                                },
                              });
                            }}
                            className="d-flex gap-2 align-items-center"
                          >
                            <div className="flex-shrink-0">
                              <img
                                src={Bot_Logo || avtarImage1}
                                alt=""
                                className="avatar-xs rounded-circle"
                              />
                            </div>
                            <div className="flex-grow-1">{Bot_Title}</div>
                          </div>
                        </td>
                        <td className="group">{Group_Name}</td>
                        {/* <td className="modal_type">{Model}</td> */}
                        <td className="type">{Type}</td>
                        <td className="category">{BOT_Category}</td>
                        <td className="user_type">
                          {/* <span className="badge bg-success-subtle text-success text-uppercase">{User_Role}</span>    */}
                          <span
                            className={`badge rounded-pill ${
                              User_Role === "BotAdmin"
                                ? "bg-primary-cust-button text-dark"
                                : User_Role === "Viewer"
                                ? "bg-warning-cust text-dark"
                                : User_Role === "BotUser"
                                ? "bg-info-subtle-cust text-dark"
                                : "" // Fallback case if none of the roles match
                            }`}
                          >
                            {User_Role === "Viewer" ? "BotViewer" : User_Role}
                          </span>
                        </td>
                        {/* <td className="last_use">{Last_Active_Date_Time && convert}</td> */}
                        <td className="last_use">
                          {Last_Active_Date_Time &&
                            moment(Last_Active_Date_Time).format("YYYY-MM-DD")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="noresult" style={{ display: "none" }}>
                <div className="text-center">
                  <lord-icon
                    src="https://cdn.lordicon.com/msoeawqm.json"
                    trigger="loop"
                    colors="primary:#121331,secondary:#08a88a"
                    style={{ width: "75px", height: "75px" }}
                  ></lord-icon>
                  <h5 className="mt-2">Sorry! No Result Found</h5>
                  <p className="text-muted mb-0">
                    We've searched more than 150+ Orders We did not find any
                    orders for you search.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default BotList;
